/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';
import FieldGuide from '../../../../form/fields/common/fieldGuide';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import getFormattedPricing from '../../utils';
import { IotOBDYSplitter, IotRaven, IotRaven5CAN_USNon_Share, IotRaven5Non_Share } from '../../../../utils/constant';

const Row = ({
  rowData,
  viewType,
  isRenewal,
  ratePlans,
  hardware,
  setHardware,
  hasServiceColumn,
  serviceLabel,
  renderServiceCell,
  serviceRowSpan
}) => {
  const {
    fields: {
      hardwareName,
      hardwareId,
      hardwareHasIncludedUnits,
      unitPrice,
      toolTip,
      hideForSimpleView,
      isAccessory,
      isRavenAccessory
    }
  } = rowData;

  if (viewType === 'simpleView' && hideForSimpleView) return null;

  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: { value3year, value2year, valueMTM },
    iotOrderDetailsSection: { labelGoAnywhere }
  } = localizedStrings;

  const [includedQuantity, setIncludedQuantity] = useState(0);
  const [additionalQuantity, setAdditionalQuantity] = useState(() =>
    _.get(hardware, `${hardwareName}.additionalQuantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);
  const handleQuantityChange = (value) => {
    if (hardwareName === IotOBDYSplitter) {
      const IotRaven5Non_Share_Quantity = _.get(hardware, `${hardwareName}.${IotRaven[IotRaven5Non_Share]}`, 0);
      const IotRaven5CAN_USNon_Share_Quantity = _.get(hardware, `${hardwareName}.${IotRaven[IotRaven5CAN_USNon_Share]}`, 0);
      const ravenAdditionalQuantity = IotRaven5Non_Share_Quantity + IotRaven5CAN_USNon_Share_Quantity
      if (value < ravenAdditionalQuantity) {
        setAdditionalQuantity(ravenAdditionalQuantity)
        setHardware(previousValue => ({
          ...previousValue,
          [hardwareName]: {
            ...previousValue[hardwareName],
            OBDQuantity: 0
          }
        }));
      } else {
        setAdditionalQuantity(value)
        setHardware(previousValue => ({
          ...previousValue,
          [hardwareName]: {
            ...previousValue[hardwareName],
            OBDQuantity: additionalQuantity ? additionalQuantity - ravenAdditionalQuantity : 0
          }
        }));
      }
    }
  }
  
  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    setHardware(previousValue => ({
      ...previousValue,
      [hardwareName]: {
        ...previousValue[hardwareName],
        includedQuantity,
        additionalQuantity,
        unitPrice,
        isAccessory,
        isRavenAccessory
      }
    }));
  }, [additionalQuantity, unitPrice]);

  useEffect(() => {
    if (hardwareName === IotOBDYSplitter) {
      const IotRaven5Non_Share_Quantity = _.get(hardware, `${hardwareName}.${IotRaven[IotRaven5Non_Share]}`, 0);
      const IotRaven5CAN_USNon_Share_Quantity = _.get(hardware, `${hardwareName}.${IotRaven[IotRaven5CAN_USNon_Share]}`, 0);
      const OBDQuantity = _.get(hardware, `${hardwareName}.OBDQuantity`, 0);
      const totalQuantity = IotRaven5Non_Share_Quantity + IotRaven5CAN_USNon_Share_Quantity + OBDQuantity
      setAdditionalQuantity(totalQuantity)
    }
  }, [_.get(hardware, `${hardwareName}.${IotRaven[IotRaven5Non_Share]}`, 0), _.get(hardware, `${hardwareName}.${IotRaven[IotRaven5CAN_USNon_Share]}`, 0)])

  useEffect(() => {
    if (viewType && rowRef.current) {
      setAdditionalQuantity(0);
      setIncludedQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  /**
   * When user adds a rate plan
   * update the included units in hardware automatically
   */
  useEffect(() => {
    if (hardwareHasIncludedUnits) {
      const includedUnits = Object.keys(ratePlans).reduce((acc, current) => {
        const totalunits = Object.keys(ratePlans[current]).reduce(
          (rateplanAcc, item) => {
            const { quantity, term } = ratePlans[current][item];
            if (item === hardwareId && [value2year, value3year].includes(term))
              return rateplanAcc + +quantity;

            return rateplanAcc;
          },
          0
        );
        return acc + totalunits;
      }, 0);
      const mtmUnits = Object.keys(ratePlans).reduce((acc, current) => {
        const totalunits = Object.keys(ratePlans[current]).reduce(
          (rateplanAcc, item) => {
            const { quantity, term } = ratePlans[current][item];
            if (item === hardwareId && term === valueMTM)
              return rateplanAcc + +quantity;

            return rateplanAcc;
          },
          0
        );
        return acc + totalunits;
      }, 0);
      if (includedUnits > 0) {
        const updatedRatePlans = {
          ...hardware,
          [hardwareName]: {
            includedQuantity: includedUnits,
            additionalQuantity: mtmUnits,
            unitPrice,
            isAccessory,
            isRavenAccessory
          }
        };
        setHardware(updatedRatePlans);
      }
      setAdditionalQuantity(mtmUnits);
      setIncludedQuantity(includedUnits);
    }
  }, [ratePlans]);

  return (
    <tr>
      {hasServiceColumn && renderServiceCell && (
        <Td
          rowSpan={serviceRowSpan}
          style={{ background: '#f7f7f7', fontWeight: '700' }}
        >
          {serviceLabel}
        </Td>
      )}
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            textAlign: 'left',
            width: '100%'
          }}
        >
          <p style={{ lineHeight: 'normal' }}>
            {hardwareName === 'TB1-LTMTEL' ? labelGoAnywhere : hardwareName}
          </p>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide isRichText tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>
      {!isRenewal && !isAccessory && (
        <Td>
          <input
            disabled
            style={{ background: '#eee' }}
            className="frg-input-field color-light"
            value={includedQuantity}
          />
        </Td>
      )}
      <Td>
        <input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={additionalQuantity}
          onChange={e => {
            setAdditionalQuantity(+e.target.value);
          }}
          onBlur={e => {
            handleQuantityChange(+e.target.value);
          }
          }
        />
      </Td>
      {!isRenewal && !isAccessory && (
        <Td>
          <input
            disabled
            style={{ background: '#eee' }}
            className="frg-input-field color-light"
            value={includedQuantity + additionalQuantity}
          />
        </Td>
      )}
      <Td>{getFormattedPricing(unitPrice)}</Td>
      <Td>{getFormattedPricing(+unitPrice * additionalQuantity)}</Td>
    </tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      hardwareName: PropTypes.string,
      hardwareId: PropTypes.string,
      hardwareHasIncludedUnits: PropTypes.bool,
      unitPrice: PropTypes.number,
      toolTip: PropTypes.shape({
        data: PropTypes.object,
        content: PropTypes.array,
        nodeType: PropTypes.string
      }),
      hideForSimpleView: PropTypes.bool.isRequired,
      isAccessory: PropTypes.bool.isRequired,
      isRavenAccessory: PropTypes.bool.isRequired
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  hardware: PropTypes.arrayOf(PropTypes.object).isRequired,
  setHardware: PropTypes.func.isRequired,
  hasServiceColumn: PropTypes.bool,
  serviceLabel: PropTypes.string,
  renderServiceCell: PropTypes.bool,
  serviceRowSpan: PropTypes.number
};

Row.defaultProps = {
  hasServiceColumn: false,
  serviceLabel: '',
  renderServiceCell: false,
  serviceRowSpan: 1
};

export default Row;
